import React, { useEffect, useState, Fragment } from 'react';
import FloatingActionBtn from '../Buttons/FloatingActionBtn';
import { Switch, Route, Link, useRouteMatch } from 'react-router-dom';
import Page from '../../containers/Page';
import ListSection from '../List/ListSection';
import ItemForm from '../Forms/ItemForm';
import ActionButtons from '../Buttons/ActionButtons';
import SearchBar from '../Forms/SearchBar';
import NoResult from '../Forms/NoResult';

export default function Products({
	setHeaderTitle,
	sortList,
	list,
	handleCheckboxChange,
	isListEmpty,
	productMethods,
	addProductsToList
}) {
	let { url } = useRouteMatch();
	const [ inputValue, setInputValue ] = useState('');

	useEffect(
		() => {
			setHeaderTitle('Produits');
		},
		[ setHeaderTitle ]
	);

	const returnedCheckedItems = (list) => {
		let checkedItems = [];
		for (const sublist in list) {
			if (list[sublist].length) {
				list[sublist].forEach((element) => {
					if (element.checked) {
						checkedItems.push(element);
					}
				});
			}
		}

		return checkedItems;
	};

	const handleSearchChange = (e) => {
		let input = e.target;
		setInputValue(input.value);
	};

	let { searchResults, searchMatch } = productMethods.search(inputValue, list);

	// If there is no match, default to the full original list
	if (!searchMatch) {
		searchResults = list;
	}
	let checkedList = returnedCheckedItems(searchResults);

	return (
		<Page id="productsPage">
			<p className="products__explanation">Créez une liste rapidement à partir des produits enregistrés</p>

			{!isListEmpty() ? (
				<Fragment>
					<SearchBar handleSearchChange={handleSearchChange} inputValue={inputValue} />
					<div>
						{!searchMatch && inputValue.length >= 3 ? <NoResult inputValue={inputValue} /> : ''}
						<ListSection
							type="roomtemp"
							list={sortList(searchResults.roomtemp, false)}
							handleCheckboxChange={handleCheckboxChange}
							page={url}
							itemMethods={productMethods}
						/>
						<ListSection
							type="fridge"
							list={sortList(searchResults.fridge, false)}
							handleCheckboxChange={handleCheckboxChange}
							page={url}
							itemMethods={productMethods}
						/>
						<ListSection
							type="freezer"
							list={sortList(searchResults.freezer, false)}
							handleCheckboxChange={handleCheckboxChange}
							page={url}
							itemMethods={productMethods}
						/>
					</div>
				</Fragment>
			) : (
				<div className="emptyList">
					<p className="emptyList__p">
						Votre liste de produits est vide.<br /> Ajoutez-y des produits!
					</p>
					<Link to="/products/new">
						<button className="emptyList__actionBtn">Ajouter un produit</button>
					</Link>
				</div>
			)}

			{checkedList.length ? (
				<ActionButtons
					confirm={{
						method: () => addProductsToList(checkedList),
						text: `Ajouter ${checkedList.length} élément(s)`
					}}
					cancel={{ method: () => productMethods.checkAll(false), text: 'Tout déselectionner' }}
					fixed={true}
				/>
			) : (
				''
			)}

			<FloatingActionBtn path={`${url}/new`} image={'add'} />
			<Switch>
				<Route path={`${url}/new`}>
					<ItemForm itemMethods={productMethods} edit={false} isProduct={true} />
				</Route>

				<Route path={`${url}/:id`}>
					<ItemForm itemMethods={productMethods} edit={true} isProduct={true} />
				</Route>
			</Switch>
		</Page>
	);
}
